var map = {
	"./ID/en.md": [
		94210,
		4210
	],
	"./ID/id.md": [
		48008,
		5627
	],
	"./MY/en-my.md": [
		97072,
		7072
	],
	"./SG/en-sg.md": [
		92356,
		2356
	],
	"./VN/en.md": [
		1157,
		1157
	],
	"./VN/vi.md": [
		37091,
		7091
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 20362;
module.exports = webpackAsyncContext;